import { useEffect, useState, useContext, useRef } from "react"
import intl from "react-intl-universal"

import PlusIcon from "../../../../../assets/icons/PlusIcons"
import Button from "../../../../atoms/Button"
import Select from "../../../../atoms/Select"
import Input from "../../../../atoms/Input"
import SwitchComponent from "../../../../atoms/Switch"
import styles from "./index.module.scss"
import { unitLocal } from "../../../../../services/local"
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { schemaAddEquipament } from "../../yup/schemaValidation"
import RcmpLoading from "../../../../atoms/Loading"
import { ModalInformation } from "../ModalInformation"
import { ModalAnalyteLinkedSameLevel } from "../ModalAnalyteLinkedSameLevel"
import { useNavigate, useParams } from "react-router-dom"
import { getControl, updateControl, createControl } from "../../../../../services/ciq"
import SaveIcon from "../../../../../assets/icons/SaveIcon"
import { toast } from "@stardust-ds/react"
import { WestgardRulesContext } from "../../../../../contexts/Equipments"
import RcmpDatePicker from "../../../../atoms/DatePicker"
import { fnFormatDateFromUTC } from "../../../../../utils/date"
import AuthContext from "../../../../../contexts/Auth"

import * as yup from "yup"

const optionsLevel = [
  { label: "1", value: "1" },
  { label: "2", value: "2" },
  { label: "3", value: "3" },
]

export const FormDuplicatedControl = ({
  children,
  setBisOpenModal,
  isChanged,
  equipment_analytes,
  setAnalytesVinculatedWithEquipment,
  setCLevel,
}) => {
  const [isChecked, setChecked] = useState(true)
  const [isLoadPage, setIsLoadPage] = useState(false)
  const [isLoadingBtn, setIsLoadingBtn] = useState(false)
  const [isCancelModal, setIsCancelModal] = useState(false)
  const [isConfirmModal, setIsConfirmModal] = useState(false)
  const [defaultValueExpiration, setDefaultValueExpiration] = useState("")
  const [defaultValueActivation, setDefaultValurActivation] = useState("")
  const [bAnalyteLinkedSameLevel, setBAnalyteLinkedSameLevel] = useState(false)
  const [dataAnalyteLinkedSameLevel, setDataAnalyteLinkedSameLevel] = useState([])

  const [defaultValueOpt, setDefaultValueOpt] = useState({})

  const { oUser } = useContext(AuthContext)
  const cUserTimeZone = oUser?.data?.user_ctimezone

  const required = intl.get("form.required_field")
  const getFormattedDate = () => {
    const currentDate = new Date()

    const day = addZero(currentDate.getDate())
    const month = addZero(currentDate.getMonth() + 1)
    const year = currentDate.getFullYear()

    const formattedDate = month + "-" + day + "-" + year
    return formattedDate
  }

  function addZero(number) {
    return number < 10 ? "0" + number : number
  }

  const formtDate = (date) => {
    const day = addZero(date.getDate())
    const month = addZero(date.getMonth() + 1)
    const year = date.getFullYear()

    const formattedDate = year + "-" + month + "-" + day

    return formattedDate
  }

  const schemaAddControl = yup.object().shape({
    control_cname: yup.string().required(required),
    control_cmanufacturer: yup.string().required(required),
    control_elevel: yup.string().required(required).nullable(),
    control_cbatch: yup.string().required(required),
    control_dexpiration: yup
      .date()
      .required(required)
      .min(new Date(getFormattedDate()), intl.get("ciq.info_data_validation")),
  })

  const navigate = useNavigate()
  const { id } = useParams()
  const {
    register,
    handleSubmit,
    setValue,
    setError,
    formState: { errors, isValid },
    trigger,
  } = useForm({
    resolver: yupResolver(schemaAddControl),
  })

  const firstErrorRef = useRef(null);

  const handleScrollToErrorField = () => {
    if (firstErrorRef.current) {
      firstErrorRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  function removeKeysObject(object, oldPrefix, newPrefix) {
    const newKeys = {}

    for (const oldKey in object) {
      if (Object.prototype.hasOwnProperty.call(object, oldKey)) {
        // Verifica se a chave antiga começa com o prefixo especificado
        if (oldKey.startsWith(oldPrefix)) {
          // Substitui o prefixo antigo pelo novo
          const newKey = oldKey.replace(oldPrefix, newPrefix)
          newKeys[newKey] = object[oldKey]
        } else {
          // Mantém a chave inalterada se não começar com o prefixo
          newKeys[oldKey] = object[oldKey]
        }
      }
    }

    return newKeys
  }

  const removeProperties = (array, ...propriedades) => {
    return array.map((objeto) => {
      propriedades.forEach((propriedade) => delete objeto[propriedade])
      return objeto
    })
  }

  const submitEditControl = async (data) => {
    try {
      setIsLoadingBtn(true)

      const control_bstatus = !data.control_bstatus ? isChecked : data.control_bstatus

      const controls = equipment_analytes.map((item) =>
        removeKeysObject(item, "eqpanlt", "cntrlanlt"),
      )

      const control_analytes = removeProperties(
        controls,
        "cntrlanlt_cjustification",
        "cntrlanlt_nimprecision_value",
      )
      const newData = {
        ...data,
        control_cmanufacturer: data.control_cmanufacturer?.trim(),
        control_cname: data.control_cname?.trim(),
        control_cobservation: data.control_cobservation?.trim(),
        control_cbatch: data.control_cbatch?.trim(),
        control_dexpiration: formtDate(data.control_dexpiration),
        control_bstatus,
        control_analytes: control_analytes.map((item) => ({
          ...item,

          // cntrlanlt_naverage: 10,
          // cntrlanlt_nstandard_deviation: 10,
          cntrlanlt_result_options: item.cntrlanlt_result_options.map((item) => {
            return {
              cntrlanltrops_resultopt_nid: item.cntrlanltrops_resultopt_nid,
              cntrlanltrops_ecompliance: item.cntrlanltrops_ecompliance,
            }
          }),
          //   {
          //     cntrlanltrops_resultopt_nid: 1,
          //     cntrlanltrops_ecompliance: "C",
          //   },
          //   {
          //     cntrlanltrops_resultopt_nid: 2,
          //     cntrlanltrops_ecompliance: "N",
          //   },
          // ],
          cntrlanlt_bstatus:
            item.cntrlanlt_bstatus === "Active" ||
            item.cntrlanlt_bstatus === "Ativo" ||
            item.cntrlanlt_bstatus === true
              ? true
              : false,
        })),
      }

      await createControl(newData)

      setIsLoadingBtn(false)
      redirect()
    } catch (err) {
      if (err.response.status === 422) {
        setBAnalyteLinkedSameLevel(true)
        setIsConfirmModal(false)
        setDataAnalyteLinkedSameLevel(err.response.data.errors.attached_analytes)
        fnOpenToastFail(err.response.data.errors.control_analytes[0])
        return
      }
      fnOpenToastFail(err.response?.data.message)
    } finally {
      setIsLoadingBtn(false)
    }
  }

  function fnOpenToastFail(message) {
    return toast({
      type: "error",
      title: "Erro",
      description: message,
    })
  }

  const fnGetControl = async () => {
    try {
      setIsLoadPage(true)

      const response = await getControl(id)

      setDefaultValueOpt({
        label: response.data.data.control_elevel,
        value: response.data.data.control_elevel,
      })

      setCLevel(response.data.data.control_elevel)

      setValue("control_cname", response.data.data.control_cname)
      setValue("control_cmanufacturer", response.data.data.control_cmanufacturer)
      setValue("control_cbatch", response.data.data.control_cbatch)
      setValue("control_dexpiration", response.data.data.control_dexpiration)
      setValue("control_cobservation", response.data.data.control_cobservation)
      setValue("control_bstatus", response.data.data.control_bstatus)

      setChecked(response.data.data.control_bstatus)

      setDefaultValueExpiration(response.data.data.control_dexpiration)

      setDefaultValurActivation(response.data.data.control_dactivation)

      const data = response.data.data.control_analytes?.map((item) => {
        return {
          anlt_cname: item.cntrlanlt_anlt.anlt_cname,
          anlt_type: item.cntrlanlt_anlt.anlt_type,
          anlt_info: item.cntrlanlt_cinfo,
          anlt_bstatus: item.cntrlanlt_bstatus,
          anlt_nid: item.cntrlanlt_anlt.anlt_nid,
          status: item.cntrlanlt_bstatus,

          eqpanlt_norder: item.cntrlanlt_norder,
          eqpanlt: item.cntrlanlt_anlt,
          eqpanlt_naverage: item.cntrlanlt_naverage,
          eqpanlt_nstandard_deviation: item.cntrlanlt_nstandard_deviation,
          eqpanlt_result_options: item.cntrlanlt_result_options,
          eqpanlt_nid: item.cntrlanlt_nid,
        }
      })

      setAnalytesVinculatedWithEquipment(data)
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoadPage(false)
    }
  }

  useEffect(() => {
    fnGetControl()
  }, [])

  const fnIsError = (message) => {
    return message?.message ? styles.error : ""
  }

  const redirect = () => {
    setIsCancelModal(false)
    setIsConfirmModal(false)
    navigate("/ciq/list-controls")
  }

  const handleValidationButtonClick = async () => {
    try {
      await trigger([
        "control_dexpiration",
        "control_cmanufacturer",
        "control_cname",
        "control_cbatch,",
        "control_elevel",
      ])

      const bNotError = Object.keys(errors).length === 0

      if (isValid || bNotError) {
        setIsConfirmModal(true)
      } else {
        console.log("O formulário contém erros.")
        handleScrollToErrorField()
      }
    } catch (error) {
      console.error("Erro ao validar campos:", error)
      handleScrollToErrorField()
    }
  }

  const fnValidationDateChange = (e) => {
    const valueDate = e.replace("00:00", "12:00")

    const currentDate = new Date()

    currentDate.setHours(0, 0, 0, 0)

    const [date] = fnFormatDateFromUTC(
      valueDate,
      "YYYY/MM/DD - HH:mm",
      cUserTimeZone,
    ).split(" ")

    const dateInserted = new Date(date)

    if (dateInserted < currentDate) {
      console.error("Date inserted is less than current date.")
      setValue("control_dexpiration", dateInserted)
      return
    }

    setValue("control_dexpiration", date.replace("/", "-"))
    setError("control_dexpiration", {
      type: "manual",
      message: "",
    })
    handleScrollToErrorField()
  }

  return (
    <>
      {isLoadPage ? (
        <div className={styles.flexCenter}>
          <RcmpLoading bShow={true} />
        </div>
      ) : (
        <form
          className={styles.formEquipaments}
          onSubmit={handleSubmit(submitEditControl)}
        >
          <div className={styles.flexLine}>
            <h2 className={styles.titlePage}>{intl.get("ciq.control_data")}</h2>

            <div className={styles.containerSwitch}>
              <label>{intl.get("ciq.header_table_list_analyte.status")}</label>
              <SwitchComponent
                width="10rem"
                label="Status"
                onClick={() => {
                  setChecked((oldState) => !oldState)
                  setValue("control_bstatus", !isChecked)
                }}
                cDisabledText={intl.get("ciq.inactive_up")}
                cAbleText={intl.get("ciq.active_up")}
                value={isChecked}
              />
            </div>
          </div>

          <div className={styles.flexLine}>
            <div className={styles.thirtyPercent}>
              <div className={`${styles.itemFlex} ${fnIsError(errors?.control_cname)}`}>
                <Input
                  label={intl.get("ciq.header_table_list_equipment.name")}
                  placeholder={intl.get("ciq.type_here")}
                  width="100%"
                  {...register("control_cname")}
                />
                {fnIsError(errors?.control_cname) && (
                  <span ref={firstErrorRef}>{errors?.control_cname.message}</span>
                )}
              </div>
            </div>
            <div
              className={`${styles.itemFlex} ${fnIsError(errors?.control_cmanufacturer)}`}
            >
              <Input
                label={intl.get("ciq.manufacturer")}
                placeholder={intl.get("ciq.type_here")}
                width="100%"
                {...register("control_cmanufacturer")}
              />
              {fnIsError(errors?.control_cmanufacturer) && (
                <span ref={firstErrorRef}>{errors?.control_cmanufacturer.message}</span>
              )}
            </div>
            <div
              className={` ${styles.itemFlex} 
               ${fnIsError(errors?.control_elevel)}      `}
              style={{}}
            >
              <Select
                className={styles.select}
                label={intl.get("ciq.level")}
                width="100%"
                options={optionsLevel}
                defaultValue={defaultValueOpt}
                searchable={false}
                placeholder={intl.get("select")}
                onSelect={(itemSelected) => {
                  if (itemSelected === null) {
                    setValue("control_elevel", null)
                  } else {
                    setValue("control_elevel", itemSelected?.value)
                    setError("control_elevel", {
                      type: "manual",
                      message: "",
                    })
                  }
                }}
              />

              {fnIsError(errors?.control_elevel) && (
                <span ref={firstErrorRef}>{errors?.control_elevel.message}</span>
              )}
            </div>

            <div
              className={`${styles.itemFlex} 
               ${fnIsError(errors?.control_dexpiration)}`}
            >
              <RcmpDatePicker
                bTime={false}
                label={intl.get("ciq.expiration")}
                onChange={fnValidationDateChange}
                defaultValue={defaultValueExpiration}
                onKeyDown={(e) => {
                  if (e.target.defaultValue.length === 1) {
                    setValue("control_dexpiration", undefined)
                  }
                }}
              />

              {fnIsError(errors?.control_dexpiration) && (
                <span ref={firstErrorRef}>{errors?.control_dexpiration.message}</span>
              )}
            </div>
            <div className={styles.itemFlex}>
              <RcmpDatePicker
                defaultValue={defaultValueActivation}
                disabled
                bTime={false}
                label={intl.get("ciq.activation")}
              />
            </div>
          </div>

          <div className={styles.flexLine}>
            <div className={styles.twentyPercent}>
              <div
                className={`${styles.itemFlex} 
               ${fnIsError(errors?.control_cbatch)}`}
              >
                <Input
                  label={intl.get("ciq.batch")}
                  placeholder={intl.get("ciq.type_here")}
                  width="100%"
                  {...register("control_cbatch")}
                />

                {fnIsError(errors?.control_cbatch) && (
                  <span ref={firstErrorRef}>{errors?.control_cbatch.message}</span>
                )}
              </div>
            </div>
            <div className={styles.itemFlex}>
              <Input
                label={`${intl.get("ciq.observations")} (${intl.get("optional")})`}
                width="100%"
                {...register("control_cobservation")}
              />
            </div>
          </div>

          <div className={styles.flexLine} style={{ marginTop: "1rem" }}>
            <h2 className={styles.titlePage}>
              {intl.get("ciq.list_analytes.exame_analyte")}
            </h2>

            <div className={styles.containerButton}>
              <Button
                type="button"
                variant="outline"
                onClick={() => {
                  setBisOpenModal(true)
                }}
              >
                <PlusIcon className={styles.plusIcon} />
                {intl.get("ciq.list_analytes.add_exame_analyte")}
              </Button>
            </div>
          </div>

          {children}

          <div className={styles.flexLine} style={{ marginTop: "1rem" }}>
            <div className={styles.containerButton}>
              <Button
                variant="outline"
                type="button"
                onClick={() => {
                  if (isChanged) {
                    setIsCancelModal(true)
                  } else {
                    redirect()
                  }
                }}
              >
                {intl.get("ciq.btn_cancel")}
              </Button>
            </div>

            <div className={styles.containerButton}>
              <Button
                className={styles.btnSubmit}
                type="button"
                onClick={() => {
                  handleValidationButtonClick()
                }}
              >
                <SaveIcon />
                {intl.get("ciq.save_control")}
              </Button>
            </div>
          </div>
          {isConfirmModal && (
            <ModalInformation
              bgBtn="#1ECB4F"
              type="submit"
              isLoad={isLoadingBtn}
              title={intl.get("ciq.edit_control", { plural: "" })}
              description={intl.get("ciq.question_save")}
              onClose={() => redirect()}
              onCancel={() => setIsConfirmModal(false)}
              onSubmit={handleSubmit(submitEditControl)}
            />
          )}
        </form>
      )}

      {isCancelModal && (
        <ModalInformation
          bgBtn="#1ECB4F"
          bShow={isCancelModal}
          title={intl.get("ciq.edit_control", { plural: "" })}
          description={intl.get("ciq.changes_not_save")}
          onClose={() => redirect()}
          onCancel={() => setIsCancelModal(false)}
        />
      )}

      {bAnalyteLinkedSameLevel && (
        <ModalAnalyteLinkedSameLevel
          title={intl.get("ciq.duplicate_link")}
          description={intl.get("ciq.message_duplicate_link")}
          onCancel={() => setBAnalyteLinkedSameLevel(false)}
          data={dataAnalyteLinkedSameLevel}
        />
      )}
    </>
  )
}
